import React from 'react';
import { useIntl } from 'react-intl';

import { Input } from '@xsolla/ui-core';
import { Search } from '@xsolla/ui-icons';

import { UserAttributes } from '../../../api/users/attributes/types';
import {
  HeaderUserWrapper,
  HeaderWrapper,
  SearchInputWrapper,
  UserIdWrapper,
  UsernameWrapper
} from './styles';
import { UserData } from './types';

type Props = {
  user: UserData;
  data: UserAttributes;
  setCurrFilterData: React.Dispatch<React.SetStateAction<UserAttributes | null>>;
};

const Header = ({ user, data, setCurrFilterData }: Props): JSX.Element => {
  const intl = useIntl();

  const onSearch = (value: string) => {
    setCurrFilterData(
      value
        ? data.filter(
            (attribute) =>
              attribute.description?.toLowerCase().includes(value.toLowerCase()) ||
              attribute.key.toLowerCase().includes(value.toLowerCase()) ||
              attribute.value?.toLowerCase().includes(value.toLowerCase())
          )
        : null
    );
  };

  return (
    <HeaderWrapper>
      <HeaderUserWrapper>
        <UsernameWrapper>{user.username}</UsernameWrapper>
        <UserIdWrapper>ID {user.id}</UserIdWrapper>
      </HeaderUserWrapper>
      <SearchInputWrapper>
        <Input
          placeholder={intl.formatMessage({ id: 'users.attributes.table.search.placeholder' })}
          uiSize="sm"
          extra={Search}
          onChange={(event) => onSearch(event.target.value)}
        />
      </SearchInputWrapper>
    </HeaderWrapper>
  );
};

export default Header;
